module.exports = __webpack_public_path__ + "static/img/bg.a8a5900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup/bg.png
// module id = 06cU
// module chunks = 5